(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        if (this.elements.button && this.elements.panel) {
          this.elements.button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.openSelector(event);
          });
          this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
          this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
          this.addEventListener('click', (event) => {
            event.stopPropagation();
          });
          this.querySelectorAll('a').forEach(item => {
            item.addEventListener('click', (event) => {
              event.stopPropagation();
              this.onItemClick(event);
            });
          });
          
          document.addEventListener('click', (event) => {
            if (!this.contains(event.target) && !this.elements.panel.hasAttribute('hidden')) {
              this.hidePanel();
            }
          });
        }
      }

      hidePanel() {
        if (this.elements.button && this.elements.panel) {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
        }
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        if (this.elements.button) this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        if (!form) return;
        
        const input = this.querySelector('input[name="language_code"], input[name="country_code"]');
        if (!input) return;
        
        const selectedValue = event.currentTarget.dataset.value;
        if (!selectedValue) return;
        
        if (input.value === selectedValue) {
          this.hidePanel();
          return;
        }
        
        input.value = selectedValue;
        
        let hiddenMethod = form.querySelector('input[name="_method"]');
        if (!hiddenMethod) {
          hiddenMethod = document.createElement('input');
          hiddenMethod.type = 'hidden';
          hiddenMethod.name = '_method';
          hiddenMethod.value = 'put';
          form.appendChild(hiddenMethod);
        }
        
        this.hidePanel();
        form.submit();
      }

      openSelector(event) {
        if (event) {
          event.stopPropagation();
        }
        if (this.elements.button && this.elements.panel) {
          const isHidden = this.elements.panel.hasAttribute('hidden');
          this.elements.button.focus();
          if (isHidden) {
            this.elements.panel.removeAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', 'true');
          } else {
            this.hidePanel();
          }
        }
      }

      closeSelector(event) {
        if (!this.elements.panel || !this.elements.button) return;
        
        const isClickInside = this.contains(event.relatedTarget);
        const isButton = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        
        if (!isClickInside || isButton) {
          this.hidePanel();
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  document.addEventListener('DOMContentLoaded', function() {
    const closeTopBtn = document.querySelector('.menu-drawer__close-top-btn');
    const menuDrawer = document.querySelector('#menu-drawer');
    const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
    
    if (closeTopBtn && menuDrawerDetails) {
      closeTopBtn.addEventListener('click', function() {
        if (menuDrawerDetails instanceof HTMLDetailsElement) {
          menuDrawerDetails.removeAttribute('open');
           document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });
    }
    
    // Also handle when menu drawer closes via other methods (e.g., clicking outside)
    if (menuDrawerDetails) {
      menuDrawerDetails.addEventListener('toggle', function() {
        if (!menuDrawerDetails.hasAttribute('open')) {
          // Remove overflow-hidden classes from body when menu closes
          document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });
    }

    const localizationSelects = document.querySelectorAll('.menu-drawer__localization-select');
    localizationSelects.forEach(select => {
      select.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      select.addEventListener('change', function(event) {
        event.stopPropagation();
      });
      select.addEventListener('mousedown', function(event) {
        event.stopPropagation();
      });
    });

    const resetButton = document.querySelector('.menu-drawer__search .reset__button');
    if (resetButton) {
      resetButton.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      resetButton.addEventListener('mousedown', function(event) {
        event.stopPropagation();
      });
    }

    const searchForm = document.querySelector('.menu-drawer__search form');
    if (searchForm) {
      searchForm.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      searchForm.addEventListener('submit', function(event) {
        event.stopPropagation();
      });
    }

    const searchInput = document.querySelector('.menu-drawer__search .search__input');
    const resetButtonMenuDrawer = document.querySelector('.menu-drawer__search .reset__button');
    
    if (searchInput && resetButtonMenuDrawer) {
      searchInput.addEventListener('click', function(event) {
        event.stopPropagation();
      });
      searchInput.addEventListener('focus', function(event) {
        event.stopPropagation();
      });
      
      function toggleResetButton() {
        if (searchInput.value.length > 0) {
          resetButtonMenuDrawer.classList.remove('hidden');
        } else {
          resetButtonMenuDrawer.classList.add('hidden');
        }
      }
      
      toggleResetButton();
      
      searchInput.addEventListener('input', function() {
        toggleResetButton();
      });
      
      const searchFormMenuDrawer = searchInput.closest('form');
      if (searchFormMenuDrawer) {
        searchFormMenuDrawer.addEventListener('reset', function() {
          setTimeout(toggleResetButton, 0);
        });
      }
    }

    // Close country selector dropdowns when clicking outside or on search (capture so we run before search stopPropagation)
    document.addEventListener('click', function(event) {
      const headerLocalization = document.querySelector('.header-localization');
      const menuDrawerLocalizations = document.querySelectorAll('.menu-drawer__localization');
      const clickedOnSearch = event.target.closest('.header__search, .menu-drawer__search');
      
      // Close header localization dropdown if open and click is outside (or on search)
      if (headerLocalization && headerLocalization.hasAttribute('open')) {
        if (!headerLocalization.contains(event.target) || clickedOnSearch) {
          headerLocalization.removeAttribute('open');
        }
      }
      
      // Close all menu drawer localization dropdowns (language + country) if open and click is outside (or on search)
      menuDrawerLocalizations.forEach(function(details) {
        if (details.hasAttribute('open') && (!details.contains(event.target) || clickedOnSearch)) {
          details.removeAttribute('open');
        }
      });
    }, true);

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nine-reasons-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.nineReasonsCountdownInitialized) return;
    window.nineReasonsCountdownInitialized = true;

    const getRemainingParts = () => {
      const now = new Date();
      const endOfDay = new Date(now);
      endOfDay.setHours(24, 0, 0, 0);

      const diff = Math.max(0, endOfDay.getTime() - now.getTime());
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      const pad = (value) => String(value).padStart(2, '0');

      return {
        hours: pad(hours),
        minutes: pad(minutes),
        seconds: pad(seconds),
      };
    };

    const updateCountdowns = () => {
      document.querySelectorAll('[data-nine-reasons-countdown]').forEach((timer) => {
        const parts = getRemainingParts();
        const hours = timer.querySelector('[data-countdown-hours]');
        const minutes = timer.querySelector('[data-countdown-minutes]');
        const seconds = timer.querySelector('[data-countdown-seconds]');

        if (hours && minutes && seconds) {
          hours.textContent = parts.hours;
          minutes.textContent = parts.minutes;
          seconds.textContent = parts.seconds;
          return;
        }

        const prefix = timer.dataset.countdownPrefix;
        const formatted = `${parts.hours} : ${parts.minutes} : ${parts.seconds}`;
        timer.textContent = prefix ? `${prefix} ${formatted}` : formatted;
      });
    };

    updateCountdowns();
    setInterval(updateCountdowns, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nine-reasons-promo-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.nineReasonsCountdownInitialized) return;
    window.nineReasonsCountdownInitialized = true;

    const getRemainingParts = () => {
      const now = new Date();
      const endOfDay = new Date(now);
      endOfDay.setHours(24, 0, 0, 0);

      const diff = Math.max(0, endOfDay.getTime() - now.getTime());
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      const pad = (value) => String(value).padStart(2, '0');

      return {
        hours: pad(hours),
        minutes: pad(minutes),
        seconds: pad(seconds),
      };
    };

    const updateCountdowns = () => {
      document.querySelectorAll('[data-nine-reasons-countdown]').forEach((timer) => {
        const parts = getRemainingParts();
        const hours = timer.querySelector('[data-countdown-hours]');
        const minutes = timer.querySelector('[data-countdown-minutes]');
        const seconds = timer.querySelector('[data-countdown-seconds]');

        if (hours && minutes && seconds) {
          hours.textContent = parts.hours;
          minutes.textContent = parts.minutes;
          seconds.textContent = parts.seconds;
          return;
        }

        const prefix = timer.dataset.countdownPrefix;
        const formatted = `${parts.hours} : ${parts.minutes} : ${parts.seconds}`;
        timer.textContent = prefix ? `${prefix} ${formatted}` : formatted;
      });
    };

    updateCountdowns();
    setInterval(updateCountdowns, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skincare-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizeKey = (value) =>
      String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\s_]+/g, '-')
        .replace(/[^a-z0-9-]/g, '');

    const parseJson = (node, fallback) => {
      if (!node) return fallback;
      try {
        return JSON.parse(node.textContent || '');
      } catch (error) {
        return fallback;
      }
    };

    const parseScoreRules = (rules) => {
      const scores = [];
      String(rules || '')
        .split(/[\n,;]+/)
        .map((rule) => rule.trim())
        .filter(Boolean)
        .forEach((rule) => {
          const parts = rule.split(/[:=]/);
          const key = normalizeKey(parts[0]);
          const points = Number.parseFloat(parts[1]);
          if (key) {
            scores.push({ key, points: Number.isFinite(points) ? points : 1 });
          }
        });
      return scores;
    };

    class SkincareQuiz {
      constructor(root) {
        this.root = root;
        this.source = root.querySelector('[data-sq-source]');
        this.config = parseJson(root.querySelector('[data-sq-config]'), { labels: {} });
        this.labels = this.config.labels || {};
        this.quiz = root.querySelector('[data-sq-quiz]');
        this.form = root.querySelector('[data-sq-form]');
        this.step = root.querySelector('[data-sq-step]');
        this.progress = root.querySelector('[data-sq-progress]');
        this.progressbar = root.querySelector('[data-sq-progressbar]');
        this.title = root.querySelector('[data-sq-title]');
        this.helper = root.querySelector('[data-sq-helper]');
        this.answers = root.querySelector('[data-sq-answers]');
        this.error = root.querySelector('[data-sq-error]');
        this.back = root.querySelector('[data-sq-back]');
        this.next = root.querySelector('[data-sq-next]');
        this.resultWrap = root.querySelector('[data-sq-result-wrap]');
        this.resultTarget = root.querySelector('[data-sq-result]');
        this.restart = root.querySelector('[data-sq-restart]');
        this.empty = root.querySelector('[data-sq-empty]');
        this.questions = this.readQuestions();
        this.results = this.readResults();
        this.resultOrder = Array.from(this.results.keys());
        this.index = 0;
        this.selections = new Map();
        this.bind();
        this.start();
      }

      readQuestions() {
        return Array.from(this.source.querySelectorAll('[data-quiz-question-block]'))
          .map((block) => {
            const question = parseJson(block.querySelector('[data-quiz-question-meta]'), null);
            if (!question) return null;
            question.answers = Array.from(block.querySelectorAll('[data-quiz-answer]'))
              .map((node) => parseJson(node, null))
              .filter((answer) => answer && answer.label);
            return question;
          })
          .filter((question) => question && question.title && question.answers.length);
      }

      readResults() {
        const results = new Map();
        Array.from(this.source.querySelectorAll('template[data-quiz-result]')).forEach((template) => {
          const key = normalizeKey(template.dataset.resultKey);
          if (key && !results.has(key)) {
            results.set(key, template);
          }
        });
        return results;
      }

      bind() {
        this.form.addEventListener('change', () => this.storeCurrentSelection());
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.goNext();
        });
        this.back.addEventListener('click', () => this.goBack());
        this.restart.addEventListener('click', () => this.reset());
      }

      start() {
        if (!this.questions.length || !this.results.size) {
          this.quiz.hidden = true;
          this.resultWrap.hidden = true;
          this.empty.hidden = false;
          return;
        }
        this.empty.hidden = true;
        this.resultWrap.hidden = true;
        this.quiz.hidden = false;
        this.renderQuestion();
      }

      currentQuestion() {
        return this.questions[this.index];
      }

      stepLabel() {
        const current = this.index + 1;
        const total = this.questions.length;
        return String(this.labels.step || '[current] / [total]')
          .replace('[current]', current)
          .replace('[total]', total);
      }

      renderQuestion() {
        const question = this.currentQuestion();
        const current = this.index + 1;
        const total = this.questions.length;
        const selected = this.selections.get(question.key) || new Set();
        this.step.textContent = this.stepLabel();
        this.progress.style.width = `${(current / total) * 100}%`;
        this.progressbar.setAttribute('aria-valuemax', String(total));
        this.progressbar.setAttribute('aria-valuenow', String(current));
        this.title.textContent = question.title;
        this.helper.textContent = question.helper || '';
        this.helper.hidden = !question.helper;
        this.error.hidden = true;
        this.error.textContent = '';
        this.back.hidden = this.index === 0;
        this.next.textContent = this.index === total - 1 ? this.labels.finish : this.labels.next;
        this.renderAnswers(question, selected);
      }

      renderAnswers(question, selected) {
        const fragment = document.createDocumentFragment();
        question.answers.forEach((answer, answerIndex) => {
          const label = document.createElement('label');
          label.className = 'skincare-quiz__answer';

          const input = document.createElement('input');
          input.type = question.multiple ? 'checkbox' : 'radio';
          input.name = `skincare-quiz-${question.key}`;
          input.value = answer.id;
          input.checked = selected.has(answer.id);

          const icon = document.createElement('span');
          icon.className = 'skincare-quiz__answer-icon';
          icon.textContent = answer.icon || String(answerIndex + 1);

          const text = document.createElement('span');
          const title = document.createElement('span');
          title.className = 'skincare-quiz__answer-title';
          title.textContent = answer.label;
          text.append(title);

          if (answer.description) {
            const description = document.createElement('span');
            description.className = 'skincare-quiz__answer-description';
            description.textContent = answer.description;
            text.append(description);
          }

          label.append(input, icon, text);
          fragment.append(label);
        });
        this.answers.replaceChildren(fragment);
      }

      storeCurrentSelection() {
        const question = this.currentQuestion();
        const selected = new Set(
          Array.from(this.answers.querySelectorAll('input:checked')).map((input) => input.value)
        );
        this.selections.set(question.key, selected);
        this.error.hidden = true;
      }

      hasCurrentSelection() {
        const question = this.currentQuestion();
        const selected = this.selections.get(question.key);
        return selected && selected.size > 0;
      }

      goNext() {
        this.storeCurrentSelection();
        if (!this.hasCurrentSelection()) {
          this.error.textContent = this.labels.error || 'Choose an answer to continue.';
          this.error.hidden = false;
          return;
        }
        if (this.index >= this.questions.length - 1) {
          this.showResult();
          return;
        }
        this.index += 1;
        this.renderQuestion();
      }

      goBack() {
        if (this.index === 0) return;
        this.storeCurrentSelection();
        this.index -= 1;
        this.renderQuestion();
      }

      calculateResultKey() {
        const scores = new Map();
        this.questions.forEach((question) => {
          const selected = this.selections.get(question.key);
          if (!selected) return;
          selected.forEach((answerId) => {
            const answer = question.answers.find((candidate) => candidate.id === answerId);
            if (!answer) return;
            parseScoreRules(answer.scores).forEach((score) => {
              scores.set(score.key, (scores.get(score.key) || 0) + score.points);
            });
          });
        });

        const fallbackKey = normalizeKey(this.config.fallbackResultKey);
        if (!scores.size && this.results.has(fallbackKey)) return fallbackKey;

        let bestKey = this.results.has(fallbackKey) ? fallbackKey : this.resultOrder[0];
        let bestScore = Number.NEGATIVE_INFINITY;
        this.resultOrder.forEach((key) => {
          const score = scores.get(key) || 0;
          if (score > bestScore) {
            bestScore = score;
            bestKey = key;
          }
        });
        return this.results.has(bestKey) ? bestKey : this.resultOrder[0];
      }

      showResult() {
        const key = this.calculateResultKey();
        const template = this.results.get(key);
        if (!template) return;
        this.resultTarget.replaceChildren(template.content.cloneNode(true));
        this.quiz.hidden = true;
        this.resultWrap.hidden = false;
        this.resultWrap.focus({ preventScroll: true });
        this.resultWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      reset() {
        this.index = 0;
        this.selections.clear();
        this.resultTarget.replaceChildren();
        this.resultWrap.hidden = true;
        this.quiz.hidden = false;
        this.renderQuestion();
        this.quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    const init = () => {
      document.querySelectorAll('[data-sq-root]').forEach((root) => {
        if (!root.dataset.sqReady) {
          root.dataset.sqReady = 'true';
          new SkincareQuiz(root);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
